import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { RegistrationPaymentService } from 'src/shared/services/registration-payment.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registration-payment-va',
  templateUrl: './registration-payment-va.component.html',
  styleUrl: './registration-payment-va.component.scss'
})
export class RegistrationPaymentVaComponent {

  paramForm: FormGroup;
  columnsToDisplay = ['checkbox', 'student_name', 'va_number', 'total_fee', 'is_paid', 'payment_generated', 'action'];
  dataPayment: any[] = [];
  loading = false;
  loading_save = false;
  checkBox: any[] = [];
  apiSubscription: Subscription;
  checkboxForm!: FormGroup<{ [key: string]: FormControl<boolean> }>;

  searchText = '';
  filterPaid: boolean | null = null;
  filterVaGenerated: boolean | null = null;

  page = 1;
  pageSize = 10;
  totalItems = 0;

  constructor(
    private translate: TranslateService,
    private paymentService: RegistrationPaymentService,
    private rpSer: ResponseService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ){}

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular');
    this.initForm();
  }

  viewAccumulationSetup() {
    this.router.navigate(['accumulation-setup'], { relativeTo: this.route });
  }
  
  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'school_program_activity_id': new FormControl(null),
      'year_level_id': new FormControl(null)
    });
  }

  onChangeAcademicYear(item: any) {
    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);
    this.paramForm.controls['school_level_id'].setValue(null);
    this.paramForm.controls['school_program_id'].setValue(null);
    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
    this.paramForm.controls['year_level_id'].setValue(null);
  }

  onChangeSchoolLevel(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['year_level_id'].setValue(null);
    this.paramForm.controls['school_program_id'].setValue(null);
    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgram(item: any) {
    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_category_id'].setValue(null);
    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgramCategory(item: any) {
    this.paramForm.controls['school_program_category_id'].markAsTouched();
    this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);

    this.paramForm.controls['school_program_activity_id'].setValue(null);
  }

  onChangeSchoolProgramActivity(item: any) {
    this.paramForm.controls['school_program_activity_id'].markAsTouched();
    this.paramForm.controls['school_program_activity_id'].setValue(item ? item.school_program_activity_id : null);
    if (item) {{
      this.getStudentPaymentData();
    }}
  }

  clearData() {
    this.dataPayment = [];
    this.totalItems = 0;
    this.page = 1;
  }

  onSearchChange() {
    this.page = 1;
    if (this.paramForm.controls['school_program_activity_id'].value) {
      this.getStudentPaymentData();
    }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paramForm.controls['school_program_activity_id'].value) {
      this.getStudentPaymentData();
    }
  }

  onPageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getStudentPaymentData();
  }

  getStudentPaymentData() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    this.checkBox = [];
    this.loading = true;
    const filters = {
      search: this.searchText,
      is_paid: this.filterPaid,
      payment_generated: this.filterVaGenerated === false ? null : this.filterVaGenerated,
      page: this.page,
      page_size: this.pageSize
    };
    this.apiSubscription = this.paymentService.getStudentPaymentData(this.paramForm.controls['school_program_activity_id'].value, filters).subscribe(
      (response: any) => {
        if (response.status) {
          this.dataPayment = response.data;
          this.totalItems = response?.meta?.total_page ?? 0;
          const group: { [key: string]: FormControl } = {};
          this.dataPayment.forEach(item => {
            group[item.registration_payment_id] = new FormControl({ value: false, disabled: item.payment_generated });
          });
          this.checkboxForm = new FormGroup(group);
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.rpSer.showAddError();
      }
    );
  }

  getSelectedCheckboxes(): any[] {
    return Object.keys(this.checkboxForm.controls)
      .filter(key => this.checkboxForm.controls[key].value)
      .map(key => {
        const item = this.dataPayment.find(p => p.registration_payment_id == +key);
        return {
          student_id: item.student_id,
          registration_payment_id: item.registration_payment_id
        };
      });
  }

  checkAllCheckboxes(event: any) {
    const isChecked = event.checked;
  
    Object.keys(this.checkboxForm.controls).forEach(key => {
      const control = this.checkboxForm.controls[key];
      const item = this.dataPayment.find(p => p.registration_payment_id == +key);

      if (!item?.payment_generated) {
        control.setValue(isChecked);
      }
    });
  }

  registerCheckbox(event: any, paymentId: number, studentId: number) {
    if (event.checked) {
      this.checkBox.push({
        student_id: studentId,
        registration_payment_id: paymentId
      });
    } else {
      const index = this.checkBox.indexOf(paymentId);
      if (index !== -1) {
          this.checkBox.splice(index, 1);
      }
    }
  }

  generateButton() {
    const selected = this.getSelectedCheckboxes();
    if (selected.length === 0) {
      return;
    } else {
      Swal.fire({
        title: 'Confirmation',
        text: 'Generate VA for payment list?',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.onGenerateVA();
          this.checkBox = [];
        }
      });
    }
  }

  onGenerateVA() {
    const selected = this.getSelectedCheckboxes();
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    this.loading_save = true;
    this.apiSubscription = this.paymentService.generatePaymentVa({
      list: selected,
      school_location_id: this.paramForm.controls['school_location_id'].value,
      school_program_activity_id: this.paramForm.controls['school_program_activity_id'].value,
    }).subscribe(
      (response: any) => {
        if (response.status) {
          this.rpSer.showAddSuccess(response.message);
          this.getStudentPaymentData();
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading_save = false;
      },
      (error) => {
        this.loading_save = false;
        this.rpSer.showAddError();
      }
    );
  }

  generateButtonIpeka() {
    const selected = this.getSelectedCheckboxes();
    if (selected.length === 0) {
      return;
    }

    Swal.fire({
      title: 'Set Expiration Date',
      html: '<input type="date" id="expired_date" class="swal2-input" required>',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Generate VA',
      preConfirm: () => {
        const expiredDate = (document.getElementById('expired_date') as HTMLInputElement).value;
        if (!expiredDate) {
          Swal.showValidationMessage('Please select an expiration date');
          return false;
        }
        const date = new Date(expiredDate);
        const formattedDate = date.getFullYear() + '-' + 
          String(date.getMonth() + 1).padStart(2, '0') + '-' + 
          String(date.getDate()).padStart(2, '0');
        return formattedDate;
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.onGenerateVAByIpeka(result.value);
      }
    });
  }

  onGenerateVAByIpeka(expiredDate: string) {
    const selected = this.getSelectedCheckboxes();
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    this.loading_save = true;
    this.apiSubscription = this.paymentService.generatePaymentVaByIpeka({
      list: selected,
      school_location_id: this.paramForm.controls['school_location_id'].value,
      school_program_activity_id: this.paramForm.controls['school_program_activity_id'].value,
      expired_date: expiredDate
      // testing: true
    }).subscribe(
      (response: any) => {
        if (response.status) {
          this.rpSer.showAddSuccess(response.message);
          this.getStudentPaymentData();
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading_save = false;
      },
      (error) => {
        this.loading_save = false;
        this.rpSer.showAddError();
      }
    );
  }


}
